import { FileText, Download } from 'lucide-react';
import { Reveal, SectionHeading } from '../Reveal';
import LeadForm from '../LeadForm';
import { FREE_RESOURCES } from '../../data/content';

const FreeResources = () => (
  <section className="bg-white py-24 md:py-32" data-testid="free-resources-section">
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <div className="grid items-start gap-14 lg:grid-cols-2">
        <div>
          <SectionHeading
            index="10"
            overline="Free Resources"
            title="Get Free Career Resources"
            description="Downloadable guides and checklists to help you make smarter career decisions — free, practical, and instantly useful."
          />
          <div className="mt-10 grid gap-3 sm:grid-cols-2">
            {FREE_RESOURCES.map((r, i) => (
              <Reveal key={r} delay={0.05 * i}>
                <div
                  className="group flex items-center gap-3 rounded-2xl border border-line bg-mist px-5 py-4 transition-[border-color,background-color] duration-200 hover:border-coral/40 hover:bg-white"
                  data-testid={`free-resource-${r.toLowerCase().replace(/\s+/g, '-')}`}
                >
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-white text-navy shadow-card transition-colors duration-200 group-hover:bg-coral group-hover:text-white">
                    <FileText className="h-4 w-4" />
                  </span>
                  <span className="text-sm font-semibold text-navy">{r}</span>
                  <Download className="ml-auto h-4 w-4 text-slate-300 transition-colors group-hover:text-coral" />
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <Reveal delay={0.15}>
          <div className="rounded-3xl border border-line bg-white p-8 shadow-card-hover md:p-10" data-testid="free-resources-form-card">
            <h3 className="font-display text-2xl font-semibold text-navy">Get Free Resources</h3>
            <p className="mt-2 text-sm text-slate-500">
              Fill in your details and we'll send the resources straight to you.
            </p>
            <div className="mt-7">
              <LeadForm source="free-resources" buttonLabel="Get Free Resources" interestLabel="Career Interest" />
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default FreeResources;
